import { Snop } from "../../../../assets/svg-icons";

export const TMS = {
  name: "iTMS",
  shortName: "iTMS",
  route: "/tms/load-plan",
  icon: Snop,
  permissions: [],
  child: {
    "Load Plan": {
      name: "Load Plan",
      route: "/tms/load-plan",
      permissions: ["LOAD_PLAN_VIEW"],
    },
    "Order Management": {
      name: "Order Management",
      route: "/tms/order-management",
      permissions: ["TMS_ORDER_MANAGEMENT_VIEW"],
    },
    "Indent Management": {
      name: "Indent Management",
      route: "/tms/indent-management",
      permissions: ["TMS_INDENT_VIEW"],
    },
    "Dock Management":{
      name: "Dock Management",
      route: "/tms/dock-management",
      permissions: ["TMS_DOCK_MANAGEMENT_VIEW"],
    }
  },
  extraRoutes: [
    {
      route: "/tms/load-plan/edit",
      permissions: ["LOAD_PLAN_EDIT"],
    },
    {
      route: "/tms/load-plan/create",
      permissions: ["LOAD_PLAN_CREATE"],
    },
    {
      route: "/tms/order-management/create",
      permissions: ["TMS_ORDER_MANAGEMENT_VIEW"],
    },
    {
      route: "/tms/order-management/edit",
      permissions: ["TMS_ORDER_MANAGEMENT_VIEW"],
    },
  ],
};
